export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900 rounded-2xl p-8 md:p-12 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-500/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/15 text-background-50 text-xs font-medium mb-5">
                <i className="ri-smartphone-line"></i>
                <span>移动端随时访问</span>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                移动端随时掌握最新动态
              </h2>
              <p className="text-background-200/80 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                使用手机浏览器访问黑料入口即可获得完整移动端体验。
                无需下载安装，随时随地浏览最新黑料事件解读与科普盘点。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  className="flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-700 font-medium rounded-lg hover:bg-background-100 transition-colors duration-200 whitespace-nowrap text-sm"
                >
                  <i className="ri-qr-code-line"></i>
                  扫码访问
                </a>
                <a
                  href="#hero"
                  className="flex items-center gap-2 px-6 py-3 bg-background-50/15 text-background-50 font-medium rounded-lg border border-background-50/25 hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap text-sm"
                >
                  <i className="ri-share-line"></i>
                  分享给朋友
                </a>
              </div>
            </div>
            <div className="flex-shrink-0 w-48 md:w-56">
              <div className="relative">
                <div className="absolute inset-0 bg-accent-500/20 rounded-3xl blur-xl"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20a%20dark%20themed%20news%20reading%20interface%20with%20Chinese%20text%2C%20elegant%20minimal%20design%2C%20floating%20on%20dark%20background%2C%20modern%20app%20preview%20with%20warm%20accent%20colors%2C%20clean%20editorial%20layout&width=600&height=800&seq=app-heiliao&orientation=portrait"
                  alt="黑料入口移动端预览"
                  className="w-full relative z-10"
                  style={{ aspectRatio: '3/4' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}